import { useEffect, useRef } from 'react'
import { useUserContext } from '@/UserContext'
import testSoundMp3 from '@/test-sound.mp3'

type SpeakerTestProps = {
    playing: boolean
    onEnded: () => void
}
export function SpeakerTest(props: SpeakerTestProps) {
    const [userState] = useUserContext()
    const noOutput =
        userState.mediaSelection.audioOutput === '_none' || userState.mediaSelection.audioOutput === '_undef'
    const audioRef = useRef<HTMLAudioElement | null>(null)
    useEffect(() => {
        const audio = audioRef.current
        if (!audio || noOutput) return

        if (props.playing) {
            audio.play().catch((err) => {
                console.warn('Audio play failed:', err)
            })
        } else {
            audio.pause()
            audio.currentTime = 0
        }
    }, [props.playing, noOutput])

    useEffect(() => {
        const audio = audioRef.current
        if (audio && 'setSinkId' in audio) {
            if (userState.mediaSelection.audioOutput !== '_none' && userState.mediaSelection.audioOutput !== '_undef') {
                ;(audio as any)
                    .setSinkId(userState.mediaSelection.audioOutput)
                    .catch((err: any) => console.warn('setSinkId failed:', err))
            }
        }
    }, [userState.mediaSelection.audioOutput])

    return <audio ref={audioRef} src={testSoundMp3} preload="auto" onEnded={() => props.onEnded()} />
}
